import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { formatFsdbmThreshold } from '../../helpers/utils';

export const FSDBMMessage = ({ threshold, isFree }) => {
  const bodfsCutoff = useConfigService('fs:bodfsCutoff') || '4pm';
  if (!threshold) {
    return null;
  }
  const qualifyingMessage = isFree ? 'This item qualifies for ' : 'Or get '
  const formattedThreshold = formatFsdbmThreshold(threshold);
  const orderAmount = isFree ? ' when you order ': ` with $${formattedThreshold} of eligible items when you order `
  return (
    <div className="sui-rounded sui-bg-gradient-to-r sui-from-[#E0F8ED] sui-to-[#9CE8C4] sui-p-2" data-testid="fsdbm-message">
      {qualifyingMessage}
      <span className="sui-text-success sui-font-bold">{'FREE '}</span>
      <span className="sui-font-bold">Delivery Today</span>
      {orderAmount}
      by {bodfsCutoff}.
    </div>
  );
}